module.exports = __webpack_public_path__ + "static/media/insulin.cb6355c8.svg";